import { WIS_RPC_MESSAGE } from '../constants';

import executeWisRpc from './executeWisRpc';

export default function sendWisHeadsetStatus(socket, status) {
    const { command, mic } = status;

    const rpcCommand = {
        message: WIS_RPC_MESSAGE.HEADSET,
        msgdata: {
            command,
            mic
        }
    };

    executeWisRpc(socket, rpcCommand);
}
